import React from "react";
import logoImage from "@/assets/images/intelisine.png";

interface LogoProps {
  className?: string;
  // Keeping these optional props to prevent breaking existing calls, even if unused by the image
  accentColor?: string;
  textColor?: string;
}

export function Logo({ className = "h-14" }: LogoProps) {
  return (
    <img 
      src={logoImage} 
      alt="Intelisine Logo" 
      className={`${className} object-contain`}
    />
  );
}
